/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicableToDetails {
    getFixupPrototypeFunction() { return ApplicableToDetails.fixupPrototype; }

    static newInstance(model: Partial<ApplicableToDetails>): ApplicableToDetails {
        let obj = Object.assign(new ApplicableToDetails(), model);
        ApplicableToDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicableToDetails>): ApplicableToDetails {
        if (!model) return null;
        return ApplicableToDetails.newInstance(<ApplicableToDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicableToDetails) {
        if (!obj) return;

        models.ApplicableToDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicableToDetails): boolean {
        Object.setPrototypeOf(obj, ApplicableToDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Applicable to which cloud account or tenant. Example 'name':'AWS_Account_1'
     */
    name: string;

    /**
     * ID of that account.Example 'id': '61237f01e4b04a4c6b19addd'
     */
    id: string;

}
